import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import {api} from '../Login/axiosConfig';
import { Tooltip, Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Link as MuiLink } from '@mui/material';
import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header1 from '../Header/Header1';
import Footer from '../Footer/Footer';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReportIcon from '@mui/icons-material/Report';
import ShareButton from "../Share/ShareButton";
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PostRecommendations from '../Recommendations/PostRecommendations';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/system';
import UserFeedbacks from '../User/UserFeedbacks';
import GoogleMeetLogo from './GoogleMeetImage.png';
import ZoomMeetLogo from './ZoomMeetImage.png';
import TeamsMeetLogo from './TeamsMeetImage.png';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
import ViewsLikesAnalytics from './ViewsLikesAnalytics';
import { CheckCircleOutline } from '@mui/icons-material';
import { ErrorOutline } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { formatDateWithSuffix } from '../utils/formatDate';
import { formatTimeToAMPM } from '../utils/formatTime';
import CircularProgress from '@mui/material/CircularProgress';
import ReserveButton from '../UserReservations/ReserveButton';
import JoinButton from './JoinButton';
import { intToUuidString } from "../../helpers/uuidhelper.js"
import SessionActionButtons from "../SessionActionButtons.js";
import MeetingAIAssistant from '../Post/MeetingAIAssistant.js';

const API_URL = process.env.REACT_APP_API_URL;


const PostTabDetails = ({ onLogout }) => {

    const [showRecording, setShowRecording] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

    const { userId, role } = useAuth();
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [action, setAction] = useState(null);
    const [bookingCreated, setBookingCreated] = useState(false)
    const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingSeconds, setLoadingSeconds] = useState(0);
    const vidRef = useRef(null);
    const [pptUrl, setPptUrl] = useState(null);
const [openPPT, setOpenPPT] = useState(false);

    console.log("COURSE OBJECT:", course);


    useEffect(() => {
        let timer;

        if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
                setLoadingSeconds(prev => prev + 1);
            }, 1000);
        } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
        }

        return () => clearInterval(timer); // cleanup on unmount or loading = false
    }, [loading]);

    const handleViewPPT = async () => {
  try {
    const res = await api.get(`${API_URL}/posts/media-url/`, {
      params: { key: course.ppt_key },
    });

    setPptUrl(res.data.url);
    setOpenPPT(true);
  } catch (err) {
    console.error("PPT fetch error", err);
  }
};


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get(`${API_URL}/get_posted_data/?post_id=${id}`);
                setCourse(response.data[0]);
                await createRecentActivity(userId, id);
                UpdatePostViews();
                updateRecentViewedPost(userId, id);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false); // Ensures loading is set to false whether success or error
            }
        };
        fetchData();
    }, [id, userId]);  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once

    const createUserPostBookings = async () => {
        setLoading(true);
        try {
            const uuidPostId = intToUuidString(id); // int → UUID string

            const response = await fetch(`${API_URL}/create_user_post_booking/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    post_id: uuidPostId,   // UUID string
                    user_id: userId,       // UUID string
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setBookingCreated(true);
            } else {
                console.error("Booking creation failed:", data);
            }
        } catch (error) {
            console.error("Error creating booking:", error);
        } finally {
            setLoading(false);
        }
    };

    const updateRecentViewedPost = async (userId, postId) => {
        try {
            const response = await api.patch(`${API_URL}/update-recent-viewed-post/`, {
                user_id: userId,
                post_id: postId,
            });

        } catch (error) {
            console.error('Error updating recent viewed post:', error.response ? error.response.data : error.message);
        }
    };

    const ProfileAvatar = styled(Avatar)(({ theme }) => ({
        width: theme.spacing(40),
        height: theme.spacing(40),
        borderRadius: '50%',
        border: `4px solid ${theme.palette.primary.main}`,
        marginRight: theme.spacing(4),
        borderColor: '#5555',
        "&:hover": {
            transform: "translateY(-3px)",
            borderColor: '#1E90FF',
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)",
        },
    }));



    const UpdatePostViews = async () => {
        try {
            const response = await api.post(`${API_URL}/update_post_views/?post_id=${id}`);
        } catch (error) {
            console.error('Error updating post views:', error);
        }
    };

    const createRecentActivity = async (userId, postId) => {
        try {
            const response = await fetch(`${API_URL}/create_recent_activity_post/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: userId,
                    post_id: postId,
                }),
            });

            const data = await response.json();
            if (response.ok) {
            } else {
                console.error('Error logging recent activity:', data);
            }
        } catch (error) {
            console.error('Error calling create_recent_activity API:', error);
        }
    };

    if (!course) {
        return (
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(3px)',
                }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <CircularProgress
                        size={60}
                        thickness={6}
                        sx={{
                            color: 'transparent',
                            '& .MuiCircularProgress-circle': {
                                stroke: 'url(#better-gradient)',
                            },
                        }}
                    />

                    {/* SVG for Gradient */}
                    <svg width="0" height="0">
                        <defs>
                            <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#f30b96ff" />
                                <stop offset="50%" stopColor="#221ce0ff" />
                                <stop offset="100%" stopColor="#0eacebff" />
                            </linearGradient>
                        </defs>
                    </svg>

                    <Typography
                        variant="h6"
                        sx={{
                            mt: 2,
                            color: '#fff',
                            textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                        }}
                    >
                        Loading Session Details...
                    </Typography>
                </Box>
            </Box>
        );

    }


    const formatStartTime = (time) => {
        const [hours, minutes] = time.split(':');
        const dateObj = new Date();
        dateObj.setHours(hours);
        dateObj.setMinutes(minutes);

        const formatter = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit', minute: '2-digit', hour12: true
        });

        return formatter.format(dateObj); // returns time in AM/PM format
    }
    const handleViewAttendance = () => {
  navigate(`/attendance/${course.id}`);
};

    // const handlePlay = () => {
    //     setShowRecording(true);
    //     setTimeout(() => vidRef.current?.play(), 50);
    // };
    const handlePlay = () => {
  if (!course?.recording_url) return; // ❌ no recording → do nothing
  setShowRecording(true);
};

    const handleClose = (e) => {
        e?.stopPropagation();
        if (vidRef.current) { vidRef.current.pause(); vidRef.current.currentTime = 0; }
        setShowRecording(false);
    };

    const formatDuration = (durationInMinutes) => {
        const hours = Math.floor(durationInMinutes / 60);
        const minutes = durationInMinutes % 60;

        // If duration is less than an hour, only show minutes
        if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        }

        return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    };

    const formatExperience = (experience) => {
        // If experience exists and is in the format HH:MM
        if (experience) {
            let minutes = experience.split(':')[0];  // Extract the minute value before ":"
            return `${minutes} min`;
        } else {
            return "New user";  // If no experience, return "New user"
        }
    }


    const {
        topic_name, section_name, subsection_name, description, language, date, start_time,
        duration, seats_left, total_seats, name, surname, profile_picture,
        about, rating, experience, id: cardId, price,
        facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, user_id, meeting_platform, media_url, media_type, meeting_link
    } = course;

    const durationFormatted = formatDuration(duration)
    const teacherRating = rating || "Not rated yet";
    const formattedStartTime = formatStartTime(start_time);
    const formatedExperience = formatExperience(experience)

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isAdminOrSales =
  role === "admin" || role === "anthra-sales-executive";

const isSessionOver = (() => {
  if (!date || !start_time || !duration) return false;

  const now = new Date();

  const [year, month, day] = date.split("-");
  const [hours, minutes] = start_time.split(":");

  const sessionStart = new Date(
    year,
    month - 1,
    day,
    hours,
    minutes
  );

  const sessionEnd = new Date(sessionStart);
  sessionEnd.setMinutes(sessionEnd.getMinutes() + Number(duration));

  return now > sessionEnd;
})();


    return (
        <div>
            <Header1 userId={userId} onLogout={onLogout} />


            <Box sx={{ backgroundColor: "#000000", minHeight: "100vh", marginTop: "50px", marginBottom: "100px" }}>
                <Grid container spacing={3} sx={{ height: "100%", backgroundColor: '#000000', justifyContent: 'center' }}>



                    <Grid item xs={12} sm={10} md={8} lg={8}>

                        <Box sx={{
                            position: 'relative',
                            padding: { xs: "2rem", sm: "3rem" }, // Responsive padding
                            backgroundColor: "#2222", // Darker background for modern look
                            color: "#fff",
                            borderRadius: "16px",
                            height: "100%",
                            boxSizing: "border-box",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                            "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
                            },
                        }}>


                            {/* {media_type === 'video' ? (
                                <Box
                                    component="video"
                                    src={media_url}
                                    controls
                                    sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
                                />
                            ) : (
                                <Box
                                    component="img"
                                    src={media_url}
                                    alt="media"
                                    sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
                                />
         
         
                                )} */}


                            <Box
                                sx={{
                                    position: "relative", borderRadius: "14px", overflow: "hidden",
                                    cursor: showRecording ? "default" : "pointer", background: "#0a0a0a",
                                    aspectRatio: "16/9"
                                }}
                                onClick={!showRecording ? handlePlay : undefined}
                            >
                                
                                {/* <Box component="img" src={media_url} alt="poster"
                                    sx={{
                                        position: "absolute", inset: 0, width: "100%", height: "100%",
                                        objectFit: "cover", borderRadius: "14px",
                                        transition: "opacity 0.6s ease, transform 0.6s ease",
                                        opacity: showRecording ? 0 : 1,
                                        transform: showRecording ? "scale(1.03)" : "scale(1)"
                                    }} /> */}

                                    {media_type === "video" ? (
<Box
  component="video"
  src={media_url}
  controls
  controlsList="nodownload noplaybackrate"
  disablePictureInPicture
  playsInline
  onContextMenu={(e) => e.preventDefault()}
  sx={{
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "14px",
    opacity: showRecording ? 0 : 1,
  }}
/>
) : (
  <Box
    component="img"
    src={media_url}
    alt="poster"
    sx={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "14px",
      opacity: showRecording ? 0 : 1,
    }}
  />
)}

                              
                                {!showRecording && (
                                    <Box sx={{
                                        position: "absolute", inset: 0, pointerEvents: "none",
                                        background: "linear-gradient(105deg, transparent 35%, rgba(255,255,255,0.06) 50%, transparent 65%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 3.5s ease-in-out infinite",
                                        "@keyframes shimmer": { "0%": { backgroundPosition: "200% 0" }, "100%": { backgroundPosition: "-200% 0" } }
                                    }} />
                                )}

                                {!showRecording && course.recording_url && (
                                    <Box sx={{
                                        position: "absolute", inset: 0, display: "flex", alignItems: "center",
                                        justifyContent: "center", "&:hover .play-orb": { transform: "scale(1.1)" }
                                    }}>
                                        {[0, 0.9].map((delay, i) => (
                                            <Box key={i} sx={{
                                                position: "absolute", width: 70, height: 70, borderRadius: "50%",
                                                border: "1.5px solid rgba(255,255,255,0.3)",
                                                animation: `pulse 2.2s ease-out ${delay}s infinite`,
                                                "@keyframes pulse": { "0%": { transform: "scale(1)", opacity: 0.4 }, "100%": { transform: "scale(1.8)", opacity: 0 } }
                                            }} />
                                        ))}
                                        <Box className="play-orb" sx={{
                                            width: 54, height: 54, borderRadius: "50%",
                                            background: "rgba(255,255,255,0.92)", display: "flex", alignItems: "center",
                                            justifyContent: "center", transition: "transform 0.2s ease"
                                        }}>
                                            <Box sx={{
                                                width: 0, height: 0, borderTop: "10px solid transparent",
                                                borderBottom: "10px solid transparent", borderLeft: "16px solid #111", ml: "3px"
                                            }} />
                                        </Box>
                                    </Box>
                                )}

                                <Box component="video" ref={vidRef} src={course.recording_url} controls
                                    controlsList="nodownload" onContextMenu={e => e.preventDefault()}
                                    onEnded={handleClose}
                                    sx={{
                                        position: "absolute", inset: 0, width: "100%", height: "100%",
                                        objectFit: "contain", borderRadius: "14px",
                                        opacity: showRecording ? 1 : 0,
                                        transition: "opacity 0.6s ease",
                                        pointerEvents: showRecording ? "all" : "none"
                                    }} />

                                {showRecording && (
                                    <IconButton onClick={handleClose}
                                        sx={{
                                            position: "absolute", top: 10, right: 10, background: "rgba(0,0,0,0.55)",
                                            color: "white", width: 32, height: 32, fontSize: 15,
                                            "&:hover": { background: "rgba(0,0,0,0.75)", transform: "scale(1.1)" }
                                        }}>
                                        ✕
                                    </IconButton>
                                )}
                            </Box>

                            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'flex-end' }}>
                                <ShareButton postUrl={`${window.location.origin}/share/post/${id}`} />
                            </Box>

                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 400,
                                    mt: "1.5rem",
                                    mb: "1.5rem",
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "left", // 👈 changed from "center" to "left"
                                    fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                    fontSize: {
                                        xs: '1rem',
                                        sm: '1.2rem',
                                        md: '1.2rem',
                                        lg: '1.2rem',
                                    },
                                    lineHeight: 1.6,
                                    "&:hover": {
                                        color: '#1E90FF',
                                    },
                                }}
                            >
                                {topic_name}
                            </Typography>


                            <Box
                                sx={{
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 2, // replaces manual margin for spacing
                                    pt: '1rem',
                                }}
                            >
                                {/* <Avatar
                                    src={profile_picture ? `${API_URL}${profile_picture}` : '/default-avatar.png'}
                                    alt={`${name || 'User'} ${surname || ''}`}
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        border: '2px solid #fff',
                                        boxShadow: '0 0 8px rgba(0,0,0,0.3)',
                                    }}
                                /> */}

                                <Avatar
                                    sx={{ width: 50, height: 50, bgcolor: '#0a2e57ff', fontSize: 28 }}
                                    src={profile_picture || undefined}
                                >
                                    {!profile_picture && name
                                        ? name.charAt(0).toUpperCase()
                                        : null}
                                </Avatar>


                                <Tooltip title="Click to view" placement="bottom">
                                    <Typography
                                        variant="h6"
                                        onClick={() => navigate(`/expert-profile?expert_id=${user_id}`)}
                                        sx={{
                                            fontWeight: 'bold',
                                            color: '#fff',
                                            fontFamily: "'Helvetica', sans-serif",
                                            letterSpacing: '0.15em',
                                            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                                            cursor: 'pointer',
                                            transition: 'color 0.3s ease-in-out',
                                            '&:hover': {
                                                color: '#1E90FF',
                                            },
                                        }}
                                    >
                                        {name || 'Name'} {surname || 'Surname'}
                                    </Typography>

                                </Tooltip>
                            </Box>







                            {/* Description */}
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        borderLeft: '4px solid #1976d2',
                                        padding: 2,
                                        mt: 2,
                                        borderRadius: '8px',
                                        fontSize: '0.95rem',
                                        lineHeight: 1.6,
                                        color: '#e0e0e0',
                                        boxShadow: 'inset 0 0 5px rgba(255,255,255,0.05)',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                    }}
                                >
                                    {description || 'No description provided.'}
                                </Typography>
                            </Grid>






                            {/* Grid of details */}
                            <Grid container spacing={2} justifyContent="left" sx={{ mt: 1, mb: 5 }}>
                                {/* Date + Time + Duration */}
                                <Grid item xs={12} sm="auto">
                                    <Typography
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: { xs: 0.5, sm: 1 },
                                            fontWeight: 600,
                                            fontSize: { xs: '0.875rem', sm: '1rem' },
                                            color: '#ffffff',
                                            background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
                                            px: { xs: 1.5, sm: 2 },
                                            py: { xs: 0.25, sm: 0.5 },
                                            borderRadius: '18px',
                                            boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
                                            whiteSpace: 'nowrap',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.4)',
                                            letterSpacing: 0.4,
                                            userSelect: 'none',
                                            width: 'fit-content',
                                            maxWidth: '100%',
                                            overflowX: 'auto', // Prevents overflow on very small screens
                                            cursor: 'default',
                                        }}
                                    >
                                        🗓
                                        <span>
                                            {formatTimeToAMPM(start_time)} • {formatDateWithSuffix(date)} • {durationFormatted}
                                        </span>
                                    </Typography>
                                </Grid>


                                {/* Language */}
                                <Grid item>
                                    <Typography
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            color: '#ffffff',
                                            background: 'linear-gradient(135deg, #c78b1cff, #27231aff)',
                                            px: 2,
                                            py: 0.5,
                                            borderRadius: '20px',
                                            boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                                            letterSpacing: 0.3,
                                            whiteSpace: 'nowrap',
                                            textShadow: '0 0 4px rgba(0,0,0,0.25)',
                                            userSelect: 'none',
                                            cursor: 'default',
                                            width: 'fit-content',
                                        }}
                                    >
                                        🗣 {language || "N/A"}
                                    </Typography>
                                </Grid>

                                {/* Price */}
                                {/* <Grid item>
                                    <Typography
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            color: '#ffffff',
                                            background: 'linear-gradient(135deg, #bcc71cff, #27231aff)',
                                            px: 2,
                                            py: 0.5,
                                            borderRadius: '20px',
                                            boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                                            letterSpacing: 0.3,
                                            whiteSpace: 'nowrap',
                                            textShadow: '0 0 4px rgba(0,0,0,0.25)',
                                            userSelect: 'none',
                                            cursor: 'default',
                                            width: 'fit-content',
                                        }}
                                    >
                                        ₹{price}
                                    </Typography>
                                </Grid> */}


                            </Grid>

                            {/* {!(paymentStatus === 'success' || bookingCreated) && (
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
    <ReserveButton postId={id} />
  </Box>
)} */}

                            <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                                {/* <Button
                                    variant="contained"
                                    color="success"
                                    href={meeting_link || '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    disabled={!meeting_link}
                                    sx={{
                                        borderRadius: '20px',
                                        px: 4,
                                        py: 1.5,
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        boxShadow: '0 4px 12px rgba(0, 128, 0, 0.3)',
                                        '&:hover': {
                                            boxShadow: meeting_link
                                                ? '0 6px 16px rgba(0, 128, 0, 0.5)'
                                                : 'none',
                                        },
                                    }}
                                >
                                    Join
                                </Button> */}

                                {/* <JoinButton meeting_link={meeting_link} /> */}
                           <JoinButton
  postId={course.id}
  hostUserId={course.user_id}
  hostName={`${course.name} ${course.surname}`}
  title={course.topic_name}
  date={course.date}
  startTime={course.start_time}
  duration={course.duration}
/>

{/* <MeetingAIAssistant
  course={course}
  recordingUrl={course.recording_url}
  postId={id}
  userId={userId}
/> */}
{/* {isAdminOrSales && isSessionOver && (
  <Button
    variant="outlined"
    onClick={handleViewAttendance}
    sx={{
      mt: 2,
      borderRadius: "20px",
      px: 3,
      py: 1.2,
      fontWeight: 600,
      textTransform: "none",
      borderColor: "#1E90FF",
      color: "#1E90FF",

      "&:hover": {
        backgroundColor: "rgba(30,144,255,0.1)",
        borderColor: "#1E90FF",
      },
    }}
  >
    View Attendance
  </Button>
)} */}
{/* {course.ppt_key ? (
  <Button
    variant="contained"
    onClick={handleViewPPT}
    sx={{
      mt: 2,
      borderRadius: "20px",
      px: 3,
      py: 1,
      fontWeight: 600,
      textTransform: "none",
      background: "#1976d2"
    }}
  >
    View PPT
  </Button>
) : (
  <Button
    variant="outlined"
    disabled
    sx={{
      mt: 2,
      borderRadius: "20px",
      px: 3,
      py: 1,
      fontWeight: 600,
      textTransform: "none",
      borderColor: "#888",
      color: "#888"
    }}
  >
    No PPT Uploaded Yet
  </Button>
)}

<Dialog open={openPPT} onClose={() => setOpenPPT(false)} maxWidth="md" fullWidth>
  <DialogTitle>PPT Viewer</DialogTitle>

  <DialogContent>
    {pptUrl && (
      <iframe
        src={pptUrl}
        width="100%"
        height="500px"
        title="ppt"
      />
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenPPT(false)}>Close</Button>
  </DialogActions>
</Dialog> */}
                                {/* <SessionActionButtons course={course} onWatchRecording={() => setShowRecording(true)}/> */}



                            </Grid>



                            {/* 
                            {(paymentStatus === 'success' || bookingCreated) ? (

                                <Box
                                    sx={{
                                        mt: 4,
                                        p: { xs: 2, sm: 3 },
                                        textAlign: 'center',
                                        borderRadius: 2,
                                        backgroundColor: '#1a1a1a', // dark card background
                                        boxShadow: 4,
                                        maxWidth: 600,
                                        margin: 'auto',
                                        border: '1px solid #2e7d32', // optional green border for emphasis
                                    }}
                                >
                                    <CheckCircleOutline
                                        sx={{
                                            fontSize: { xs: 40, sm: 50 },
                                            color: '#4caf50', // Material green
                                            mb: 1,
                                        }}
                                    />

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            color: '#4caf50',
                                            fontWeight: 700,
                                            letterSpacing: 4,
                                            fontSize: {
                                                xs: '1.25rem',
                                                sm: '1.5rem',
                                                md: '1.75rem',
                                            },
                                            mb: 1,
                                        }}
                                    >
                                        Booking Confirmed!
                                    </Typography>

                                    {price > 0 && (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: '#cccccc', // soft light gray for dark background
                                                letterSpacing: 2,
                                                fontSize: {
                                                    xs: '0.95rem',
                                                    sm: '1rem',
                                                },
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            Thank you for your payment. We've successfully received your booking.
                                        </Typography>
                                    )}


                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#aaaaaa',
                                            fontSize: {
                                                xs: '0.85rem',
                                                sm: '0.95rem',
                                            },
                                            letterSpacing: 2,
                                        }}
                                    >
                                        You can view your booking in{' '}
                                        <MuiLink
                                            component={Link}
                                            to={`/my-booking-tab-details/${id}`}
                                            underline="hover"
                                            sx={{ color: '#ffffff', fontWeight: 'bold' }} // Customize as needed
                                        >
                                            My Bookings
                                        </MuiLink>.
                                    </Typography>
                                </Box>
                            ) : paymentStatus === 'cancelled' ? (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            mt: 4,
                                            px: 3,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                                background: 'rgba(231, 76, 60, 0.1)',
                                                borderRadius: '10px',
                                                padding: '1rem 1.75rem',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.03)',
                                                    boxShadow: '0 8px 18px rgba(0, 0, 0, 0.25)',
                                                },
                                            }}
                                        >
                                            <ErrorOutline
                                                sx={{
                                                    fontSize: { xs: 32, sm: 40 },
                                                    color: '#e74c3c',
                                                }}
                                            />

                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#e74c3c',
                                                    fontWeight: 600,
                                                    letterSpacing: 2,
                                                    fontSize: {
                                                        xs: '1rem',
                                                        sm: '1.2rem',
                                                        md: '1.4rem',
                                                    },
                                                    textAlign: 'center',
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                Payment was cancelled. Please try again.
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Button
                                        component={Link}
                                        to={`/payments/post/${id}`}
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            marginTop: "2rem",
                                            backgroundColor: "#2980b9",
                                            color: "#fff",
                                            letterSpacing: 7,
                                            textTransform: "none",
                                            padding: "1rem",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Retry Payment
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        component={Link}
                                        to={price > 0 ? `/payments/post/${id}` : '#'} // Conditionally navigate
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            marginTop: "2rem",
                                            background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                            color: "#fff",
                                            textTransform: "none",
                                            letterSpacing: 7,
                                            padding: "1rem 2rem", // Add horizontal padding for better appearance
                                            fontWeight: "bold",
                                            fontSize: {
                                                xs: "1rem", // Smaller size for mobile
                                                sm: "1.1rem", // Medium size for tablets and small screens
                                                md: "1.2rem", // Larger size for desktops
                                            },
                                            borderRadius: "50px", // Rounded, pill-shaped button for a modern look
                                            boxShadow: "0 12px 18px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
                                            textAlign: "center",
                                            transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease", // Smooth transitions for hover effects
                                            "&:hover": {
                                                background: "linear-gradient(45deg, #1e90ff, #1c70ff)", // Slightly darker gradient on hover
                                                transform: "scale(1.05)", // Slight zoom effect on hover for interactivity
                                                boxShadow: "0 18px 30px rgba(0, 0, 0, 0.2)", // Stronger shadow on hover for more depth
                                            },
                                            "@media (max-width: 600px)": {
                                                padding: "0.8rem 1.5rem", // Adjust padding for small screens
                                            },
                                        }}
                                        onClick={() => {
                                            if (price <= 0) {
                                                setOpenConfirmDialog(true);
                                            }
                                        }}
                                    >
                                        Book Now
                                    </Button>
                                </>
                            )} */}

                            {/* <Grid container spacing={2} sx={{
                                justifyContent: "center", marginTop: "5px", backgroundColor: '#1111', borderColor: '#5555',
                                borderRadius: "15px",
                                "&:hover": {
                                    borderColor: '#1E90FF',
                                },
                            }}>




                            </Grid> */}


                        </Box>

                    </Grid>

                    <Dialog
                        open={openConfirmDialog}
                        onClose={() => setOpenConfirmDialog(false)}
                        PaperProps={{
                            sx: {
                                borderRadius: "16px",
                                padding: 2,
                                backgroundColor: "#000000", // Dark background
                                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
                                maxWidth: 420,
                                mx: 'auto',
                            },
                        }}
                        transitionDuration={300}
                    >
                        <DialogTitle
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1.5rem',
                                textAlign: 'center',
                                color: '#1E90FF', // Accent color
                                pb: 1,
                            }}
                        >
                            Confirm Booking
                        </DialogTitle>

                        <DialogContent sx={{ textAlign: 'center', px: 3 }}>
                            <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
                                Are you sure you want to book this session?
                            </Typography>
                        </DialogContent>

                        <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
                            <Button
                                onClick={() => setOpenConfirmDialog(false)}
                                sx={{
                                    borderRadius: '25px',
                                    padding: '0.6rem 1.5rem',
                                    backgroundColor: '#333',
                                    color: '#ddd',
                                    textTransform: 'none',
                                    "&:hover": {
                                        backgroundColor: '#444',
                                    },
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                onClick={() => {
                                    createUserPostBookings();
                                    setOpenConfirmDialog(false);
                                }}
                                variant="contained"
                                sx={{
                                    borderRadius: '25px',
                                    padding: '0.6rem 1.8rem',
                                    textTransform: 'none',
                                    background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                    fontWeight: 'bold',
                                    letterSpacing: 1,
                                    color: '#fff',
                                    "&:hover": {
                                        transform: 'scale(1.05)',
                                        boxShadow: '0 8px 20px rgba(30, 144, 255, 0.4)',
                                    },
                                }}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {loading && (
                        <Box
                            sx={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 2000,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backdropFilter: 'blur(3px)',
                            }}
                        >
                            <Box sx={{ textAlign: 'center' }}>
                                <CircularProgress
                                    size={60}
                                    thickness={6}
                                    sx={{
                                        color: 'transparent',
                                        '& .MuiCircularProgress-circle': {
                                            stroke: 'url(#better-gradient)',
                                        },
                                    }}
                                />

                                <svg width="0" height="0">
                                    <defs>
                                        <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                                            <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                                            <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                                        </linearGradient>
                                    </defs>
                                </svg>

                                <Typography
                                    variant="h6"
                                    sx={{
                                        mt: 2,
                                        color: '#fff',
                                        textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                                    }}
                                >
                                    Loading Session Details... ({loadingSeconds} sec)
                                </Typography>
                            </Box>
                        </Box>
                    )}

                </Grid>

            </Box>

            {/* <UserFeedbacks userId={user_id} /> */}
            <IconButton
                onClick={scrollToTop}
                sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
                <ArrowUpwardIcon />
            </IconButton>
            <Footer2 />
        </div>
    );
};

export default PostTabDetails;